/**
 * Table Task Status
 * Checkmark icon used by some tables to show if something is true or false
 */
import type { SizeProp } from '@fortawesome/fontawesome-svg-core';
import React from 'react';

import Icon from '@components/Icon/Icon';
import {
  ButtonImage,
  ButtonImageContainer,
} from '@components/SideStripDesktop/SideButton.style';

import { isDevelopment } from '@constants/env';

import { useUpdateCuratorTask } from '@hooks/api/curator-task';

import type { CuratorTaskModel } from 'generated/types';

interface TableTaskStatusProps {
  task: Pick<CuratorTaskModel, 'curator_task_id' | 'status'>;
  size?: SizeProp;
}

export const TableTaskStatus: React.FC<TableTaskStatusProps> = ({
  task: { curator_task_id, status },
  size = 'xs',
}) => {
  const completed = status;
  const [updateTask, loading] = useUpdateCuratorTask();

  const handleClick = async () => {
    try {
      await updateTask({
        input: {
          curator_task_id: curator_task_id,
          curator_task: {
            status: !status,
          },
        },
      });
    } catch (e) {
      if (isDevelopment) {
        // eslint-disable-next-line no-console
        console.error(e);
      }
    }
  };

  return (
    <ButtonImageContainer
      bottom={false}
      onClick={async (e) => {
        e.stopPropagation();
        await handleClick();
      }}
      type="button"
    >
      <ButtonImage bottom={false} highlighted={false}>
        <Icon
          clickable
          color={
            // eslint-disable-next-line no-nested-ternary
            loading ? 'divider' : completed ? 'success.main' : 'error.main'
          }
          // eslint-disable-next-line no-nested-ternary
          name={loading ? 'loader' : completed ? 'circle-check' : 'circle-x'}
          size={size}
          type="fas"
        />
      </ButtonImage>
    </ButtonImageContainer>
  );
};
